
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(1160|3594|4556|5689|8266|8614)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
